module.exports = __webpack_public_path__ + "assets/img/6w.a9298f61.png";